module.exports = __webpack_public_path__ + "static/media/mq.9df94d0c.png";